import { Component, OnInit } from '@angular/core';
import { AdminService } from 'src/app/services/Admin/admin.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-setting',
  templateUrl: './setting.component.html',
  styleUrls: ['./setting.component.css']
})
export class SettingComponent implements OnInit {

  Submitted: boolean = false;
  WeekOffList: any = [];
  dropdownSettings: any = {};
  selectedItems: any = [];
  DaysList: any = [];
  Days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  constructor(private adminservice: AdminService, private lookupservice: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }

  SettingModel = {
    WeekOff: '',
    DaysArray: [],
  };

  GetWeekOff() {
    this.spinnerService.show();
    this.adminservice.GetWeekOff().subscribe((response: any) => {
      if(response.WeekOffList!=null && response.WeekOffList.length>0){
      this.WeekOffList = response.WeekOffList[0];
      this.selectedItems = [];
      var Days = this.WeekOffList.WeekOff != null ? this.WeekOffList.WeekOff.split(',') : '';
      for (var i = 0; i < this.DaysList.length; i++) {
        for (var j = 0; j < Days.length; j++) {
          if (Days[j] == this.DaysList[i].ItemName) {
            let item = {
              ItemId: this.DaysList[i].ItemId,
              ItemName: this.DaysList[i].ItemName
            }
            this.selectedItems.push(item)
            break;
          }
        }
      }
    }
      this.spinnerService.hide();
      this.SettingModel.DaysArray = this.selectedItems;
      this.globalHelper.CheckActionStatus(response);
    });
  };

  SaveWeekOff(valid) {

    this.Submitted = true;
    var WeekOff = '';
    for (var j = 0; j < this.SettingModel.DaysArray.length; j++) {
      if (WeekOff == '') {
        WeekOff = this.SettingModel.DaysArray[j].ItemName;
      }
      else {
        WeekOff = WeekOff + "," + this.SettingModel.DaysArray[j].ItemName;
      }
    }

    this.SettingModel.WeekOff = WeekOff;

    if (valid) {
      this.spinnerService.show();
      this.adminservice.SaveWeekOff(JSON.stringify(this.SettingModel)).subscribe((response: any) => {
        this.spinnerService.hide();
        this.GetWeekOff();
        this.Submitted = false;
        this.globalHelper.CheckActionStatus(response);

      });
    }

  };
  ngOnInit() {
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'ItemId',
      textField: 'ItemName',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: false
    };

    this.DaysList = [];
    for (var i = 0; i < 7; i++) {
      var item = {
        ItemId: i,
        ItemName: this.Days[i]
      }
      this.DaysList.push(item);
    }
    this.GetWeekOff();

  }

}

